export const CommonActions = {
    ACTIVATE: 'activate',
    DEACTIVATE: 'deactivate',
    DELETE: 'delete',
    EDIT: 'edit',
    RENAME: 'rename',
    SEND_REMINDERS: 'send-reminders',
} as const;

export const EvaluationActions = {
    CREATE_EVAL_360: 'create-evaluation-360',
    CREATE_SELF_EVAL: 'create-self-evaluation',
    CREATE_MANAGER_EVAL: 'create-manager-evaluation',
    SEE_SENT_CYCLES: 'see-sent-cycles',
} as const;
